import { AppType, useAppStore } from '@/stores/app.store';

export function useApp() {
  const appStore = useAppStore();

  return {
    currentApp: computed(() => appStore.current_app),
    currentAppName: computed(() => appStore.currentAppName),
    currentAppLogo: computed(() => appStore.currentAppLogo),
    currentAppFavicon: computed(() => appStore.currentAppFavicon),
  };
}
